import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowPlaylistRead = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "playlist":
        if (!permission.isUserReadable() || !permission.isGroupReadable() || !permission.isOtherReadable()) {
          return false;
        }
        break;

      case "playlist_title":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "playlist_users_relation":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
